import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { ProposedProjectController } from "services/proposedProject/controller";
import { FormRenderer, useAccordionWizard } from "stories";
import { AccordionForm } from "stories/components/accordionForm";
import { useFileUpload } from "utils/customHooks/useFileUpload";
import { useToast } from "utils/customHooks/useToast";
import { removeEmptyValues } from "../../../loanDetails/elements/borrower/LoanDetailsBorrower";
import { AppraisalFormFields } from "./AppraisalFormFields";

const proposedProjectController = ProposedProjectController();

const getAppraisalModel = () => ({
  appraised_as_complete_value_of_property: null,
  appraised_cost_to_complete: null,
  appraised_residual_land_value: null,
  appraised_value_of_land: null,
  appraised_value_of_property: null,
  appraiser_description: "",
  appraiser_name: "",
  appraiser_report_date: null,
  appraiser_report_filename: null,
  estimated_value_of_property: null,
  third_party_appraisal: false,
  total_appraised_value_of_property: null,
});

export const AppraisalQueryKey = "appraisal";
const Appraisal = ({ opportunity }) => {
  const form = useForm({
    defaultValues: getAppraisalModel(),
  });
  const params = useParams();
  const queryKey = [AppraisalQueryKey, { id: params.id }];
  const { showToast } = useToast();
  const { handleFileFields } = useFileUpload();
  const { next } = useAccordionWizard();
  const queryClient = useQueryClient();
  const { isLoading: fetchLoading } = useQuery({
    queryKey,
    queryFn: proposedProjectController.getProjectAppraisal.bind(
      null,
      params.id
    ),
    onSuccess: form.reset,
  });

  const handleUpdate = async (values) => {
    return handleFileFields(values)
      .then((values) => {
        values = removeEmptyValues(values);
        values.opportunityId = params.id;
        return values;
      })
      .then(proposedProjectController.updateProjectAppraisal);
  };

  const { mutate, isLoading: postLoading } = useMutation(handleUpdate, {
    onSuccess: () => {
      showToast("Project appraisal updated!", "success");
      next();
      queryClient.invalidateQueries(queryKey);
    },
  });

  return (
    <AccordionForm
      accordionTitle={"Project Appraisal"}
      accordionKey="project-appraisal"
      isPreLoading={fetchLoading}
      isPostLoading={postLoading}
      form={form}
      onSubmit={mutate}
    >
      <FormRenderer fields={AppraisalFormFields[opportunity.loan_type]} />
    </AccordionForm>
  );
};

export default Appraisal;
